import { Constants, ShowTypes } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

/**
 * CKC Rally Obedience entry form (CKC Rally Obedience Trial Rules & Regulations, 2025).
 * Row 1 lists the official classes (2.1.3, 18.1); row 2 the unofficial classes the club
 * offers (Chapter 19: Brace, Team). Both rows are filtered to the classes the club checked
 * when it set up the trial.
 */
export namespace CKCRallyObedience {
  const ckcRally = ShowTypes[Constants.sanctioning_club.CKC][Constants.show_type.rally_obedience];

  /** Official classes, in the order they appear on the CKC entry form. */
  export const officialLevels: string[] = Object.keys(ckcRally).filter(
    (key) => key !== Constants.dog_class_element.rally_unofficial
  );

  /** Unofficial classes offered through the platform. */
  export const unofficialLevels: string[] = ckcRally[Constants.dog_class_element.rally_unofficial];

  /** Regular (competing) official classes: every official class except Exhibition Only. */
  export const regularLevels: string[] = officialLevels.filter(
    (level) => level !== Constants.dog_class_element_level.ckc_exhibition_only
  );

  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true;

      return show.show_elements.some((se) =>
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    const toOption = (level: string) => ({ value: level, id: level });

    const officialOptions = officialLevels.filter(isElementAvailable).map(toOption);
    const unofficialOptions = unofficialLevels.filter(isElementAvailable).map(toOption);

    const formRows: IEventRegisterRow[] = [];

    if (officialOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.performance_rally_obedience,
            multiSelect: true,
            columnLayout: true,
            options: officialOptions,
          },
        ],
      });
    }

    if (unofficialOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.rally_unofficial,
            multiSelect: true,
            columnLayout: true,
            options: unofficialOptions,
          },
        ],
      });
    }

    return formRows;
  };
}
